import { BarChart3, BriefcaseBusiness, ChevronDown, Database, Gauge, LogOut, Menu, Search, Server, Settings, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

const navigation = [
  { to: "/leads", label: "داشبورد", icon: Gauge, end: true },
  { to: "/leads/projects", label: "پروژه‌ها", icon: BriefcaseBusiness, end: true },
  { to: "/leads/workers", label: "اجراکننده‌ها", icon: Server, end: true },
];

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <div className="app-shell" dir="rtl">
    <aside className={`sidebar${mobileOpen ? " is-open" : ""}`}>
      <div className="brand">
        <Link to="/leads" aria-label="چاره‌یار"><img src="/identity/charehyar-logo-light-v2.png" alt="چاره‌یار" /></Link>
        <button className="icon-button sidebar-close" type="button" onClick={() => setMobileOpen(false)} aria-label="بستن منو"><X /></button>
      </div>
      <nav aria-label="ناوبری اصلی">
        {navigation.map(({ to, label, icon: Icon, end }) => <NavLink key={label} to={to} end={end} onClick={() => setMobileOpen(false)}><Icon /><span>{label}</span></NavLink>)}
        <Link to="/leads/projects"><Search /><span>جستجوها</span></Link>
        <Link to="/leads/projects"><Database /><span>لیدها</span></Link>
        <span className="nav-disabled"><BarChart3 /><span>گزارش‌ها</span><small>بعداً</small></span>
        <span className="nav-disabled"><Settings /><span>تنظیمات</span></span>
      </nav>
      <footer><strong>چاره‌یار</strong><span>Market Intelligence · Phase 1</span></footer>
    </aside>
    <div className="workspace">
      <header className="topbar">
        <button className="icon-button menu-button" type="button" onClick={() => setMobileOpen(true)} aria-label="بازکردن منو"><Menu /></button>
        <Link className="mobile-brand" to="/leads"><img src="/identity/charehyar-logo-primary-v2.png" alt="چاره‌یار" /></Link>
        <div className="topbar-user"><span className="avatar">م</span><div><strong>مهدی</strong><small>مدیر چاره‌یار</small></div><ChevronDown /></div>
        <button className="topbar-exit" type="button"><LogOut /><span>خروج</span></button>
      </header>
      <main className="main"><Outlet /></main>
    </div>
    {mobileOpen ? <button className="sidebar-backdrop" type="button" onClick={() => setMobileOpen(false)} aria-label="بستن منو" /> : null}
  </div>;
}
